import { init, waitForElement } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { unbindOriginalSearch } from './helpers'

import "./styles/index.css"

unbindOriginalSearch('#Search-In-Modal')


init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "#Search-In-Modal",
    contentCssSelector: "#MainContent",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    serpRenderDelay: () => {
        return waitForElement({
            selector: "#MainContent",
        })
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId", "url", 
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value"
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url", 
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,

    // // Uncomment for Category Merchandising
    categoryCssSelector: '#MainContent .collection-grid-section',
        categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(() => {
    const searchFormEl = document.querySelector('.search-modal__form');
    const searchInput = searchFormEl.querySelector('#Search-In-Modal');
    
    const handleKeyDown = (event) => {
        const closeSearchBtn = document.querySelector('header .search-modal__close-button');
        if(event.key === 'Enter' && !!closeSearchBtn || event.key === 'Escape' && !!closeSearchBtn) {
            closeSearchBtn.click()
        }
    }

    if(searchInput) {
        searchInput.setAttribute('autocomplete', 'off');
        searchInput.insertAdjacentElement('afterend', searchFormEl.querySelector('.field__label'));
        searchInput.addEventListener('keydown', handleKeyDown)
    }
})